module.exports = __webpack_public_path__ + "1f8111a407d9c9cc26108a658828c088.svg";